import { jsxs as p, jsx as o } from "react/jsx-runtime";
import { useRef as S, useState as d } from "react";
import { Modal as P, CheckBoxSwitcher as y, BaseSwitcher as N, PrimaryButton as R, toast as b } from "@systemeio/ui";
import { useTranslation as j } from "../../i18n.mjs";
import { ImageCropper as q } from "./image-cropper.mjs";
import { CircleToSquareSwapIcon as B } from "../../icons/circle-to-square-swap.mjs";
import { SquareToCircleSwapIcon as T } from "../../icons/square-to-circle-swap.mjs";
function A({
  imageFile: g,
  opened: w,
  actionButtonLabel: u,
  isFetching: l,
  onClose: C,
  onCrop: _,
  isRounded: n = !1,
  allowSwitchingCroppingShape: s = !1,
  ...h
}) {
  const { t: e } = j(), i = S(void 0), [c, m] = d(!1), [t, v] = d(n), x = (a) => {
    var r, f;
    m(a), a ? (r = i.current) == null || r.showPreview() : (f = i.current) == null || f.hidePreview();
  }, I = async () => {
    var a;
    try {
      const r = await ((a = i.current) == null ? void 0 : a.getCroppedFile());
      if (!r) throw new Error();
      _(r);
    } catch {
      b.error(e("file_manager.error"));
    }
  };
  return /* @__PURE__ */ p(
    P,
    {
      title: e("file_manager.file_upload.crop_file"),
      opened: w,
      onClose: C,
      afterLeave: () => m(!1),
      isFetching: l,
      isCentered: !0,
      children: [
        /* @__PURE__ */ o(
          q,
          {
            imageCropperRef: i,
            imageFile: g,
            isRounded: s ? t : n,
            ...h
          }
        ),
        /* @__PURE__ */ p("div", { className: "mt-10 flex items-center justify-between gap-5", children: [
          /* @__PURE__ */ p("div", { className: "flex flex-wrap gap-5", children: [
            /* @__PURE__ */ o(
              y,
              {
                wrapperClassName: "flex-row",
                label: e("file_manager.preview"),
                selected: c,
                onChange: x
              }
            ),
            s && !c && /* @__PURE__ */ o(
              N,
              {
                wrapperClassName: "flex-row",
                selected: t,
                onChange: v,
                label: e(t ? "file_manager.image_cropper.rounded_crop" : "file_manager.image_cropper.square_crop"),
                switcherElement: t ? /* @__PURE__ */ o(B, {}) : /* @__PURE__ */ o(T, {})
              }
            )
          ] }),
          /* @__PURE__ */ o(R, { onClick: I, isFetching: l, children: u ?? e("file_manager.file_upload.crop_file") })
        ] })
      ]
    }
  );
}
export {
  A as ImageCropperModal
};
